var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.034,
    height: 16.034,
    viewBox: "0 0 16.034 16.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3d4463;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2037.983 -3996.983)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2054.017,4002.827v4.312h-5.879v5.878h-4.311v-5.878h-5.844v-4.312h5.844v-5.844h4.311v5.844Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.2a3007d8178ee8b799708946fdf08b23.svg";
export { ForwardRef as ReactComponent };